import "../../internal/features/stages/middleware.js";
import "../../internal/features/stages/reducer.js";
import { selectCurrent, selectCurrentEntity, selectLoading, selectError } from "../../internal/features/stages/selectors.js";
import { useAppActions } from "../../internal/shared/lib/store/hooks/useAppActions.js";
import { useAppSelector } from "../../internal/shared/lib/store/hooks/useAppSelector.js";
function useCurrentStage() {
  const currentStage = useAppSelector(selectCurrent);
  const currentEntityStage = useAppSelector(selectCurrentEntity);
  const loading = useAppSelector(selectLoading);
  const error = useAppSelector(selectError);
  const {
    stages: { setCurrent }
  } = useAppActions();
  return {
    current: currentStage,
    data: currentEntityStage,
    loading,
    error,
    actions: {
      setCurrent
    }
  };
}
export {
  useCurrentStage
};
